/*
 * @Author: zhujian
 * @Date: 2019-09-16 11:31:05
 * @Last Modified by: zhujiapeng
 * @Last Modified time: 2021-01-15 09:34:47
 */

import React, { useEffect, useState } from 'react';
// import DefaultIcon from '../common/DefaultIcon';
// import * as data from './data.json'
import Outline from './Outline';
import StudentSearchSelect from '../common/StudentSearchSelect';
import AxiosTS from '../../core/axios';
import { convertBase64ToBlob, random_string } from '../../core/function';
import Upload from '../../core/upload';
import * as faceapi from 'face-api.js';
import _ from 'underscore';
import { getRem } from '../util/util';
import { getParameterByName } from '../../core/function';
import './StudentInfoPage.less';
import { message, Modal, Spin, Icon, Switch } from 'antd';

let inputSize = 512;
let scoreThreshold = 0.5;
const antIcon = <Icon type='loading' style={{ fontSize: 24 }} spin />;

const AttendPage = props => {
  const [studentInfo, setStudentInfo] = useState({});
  const [dataUrl, setDataUrl] = useState('');
  const [hasStudent, setHasStudent] = useState(false);
  const [imageList, setImageList] = useState([]);
  const [submit, setSubmit] = useState(false);
  const [submiting, setSubmiting] = useState(false);
  const [nodevice, setNodevice] = useState(false);
  const [status, setStatus] = useState(1);
  const [resourceId, setResourceId] = useState('');
  const [qrcodeModalFlag, setQrcodeModalFlag] = useState(false); // 分享采集二维码弹窗标志
  const [parentEntryFlag, setParentEntryFlag] = useState(false); // 家长端采集入口弹窗标志
  const [checked, setChecked] = useState(false); // 家长端采集人脸的开关标志
  const [collectionImg, setCollectionImg]=useState('');
  const getMedia = constraints => {
    //获得video摄像头区域
    let video = document.getElementById('video');
    //这里介绍新的方法，返回一个 Promise对象
    // 这个Promise对象返回成功后的回调函数带一个 MediaStream 对象作为其参数
    // then()是Promise对象里的方法
    // then()方法是异步执行，当then()前的方法执行完后再执行then()内部的程序
    // 避免数据没有获取到
    const mediaDevices = navigator.mediaDevices;
    let promise = mediaDevices.getUserMedia(constraints);
    promise.then(
      MediaStream => {
        try {
          video.srcObject = MediaStream;
          setNodevice(false);
          video.play();
        } catch (error) {
          console.error(error);
        }
      },
      error => {
        setNodevice(true);
        Modal.confirm({
          title: `请检测摄像头设备是否正确连接，并允许访问！`
        });
      }
    );
  };

  useEffect(() => {
    window.onresize = _.debounce(onResize, 500);
    return () => {
      window.onresize = null;
    };
  }, []);

  useEffect(() => {
    if (props.studentId) {
      selectStudent({
        studentId: getParameterByName('studentId'),
        studentName: getParameterByName('name'),
        phone: getParameterByName('phone')
      });
    }
    const mediaDevices = navigator.mediaDevices;
    const rem = getRem();
    const constraints = {
      video: {
        width: 60 * rem,
        height: 45 * rem
      }
    };
    let promise = mediaDevices && mediaDevices.getUserMedia(constraints);
    promise.then(
      () => {
        initFaceDetect();
      },
      error => {
        setNodevice(true);
        Modal.confirm({
          title: `请检测摄像头设备是否正确连接，并允许访问！`
        });
      }
    );
  }, []);

  function onResize() {
    const rem = getRem();
    getMedia({
      video: {
        width: 60 * rem,
        height: 45 * rem
      }
    });
  }

  /**
   * 获取家长端采集人脸开关配置
   */
  function setCheckedValue() {
    const param = {
      instId: window.userAdminInfo.instId,
      configTypes: ['OPEN_C_FACE']
    };
    AxiosTS.Business('public/config/getCampusConfigs', param).then(res => {
      if (res.result[0].configValue === 'FALSE') {
        setChecked(false);
      } else {
        setChecked(true);
      }
    });
  }

  const initFaceDetect = async () => {
    const rem = getRem();
    const constraints = {
      video: {
        width: 60 * rem,
        height: 45 * rem
      }
    };
    faceapi.nets.tinyFaceDetector.load('./modal').then(() => {
      const input = document.getElementById('testimg'); //  帧图 img
      // console.log(dataUrl)
      const options = new faceapi.TinyFaceDetectorOptions({ inputSize, scoreThreshold }); // 人脸识别参数
      // console.log(options)
      // console.log(options, 'ddddd')
      faceapi.detectSingleFace(input, options).then(() => {
        // 人脸识别  使用img
        setStatus(2);
        setTimeout(() => {
          getMedia(constraints);
        }, 100);
      });
    });
  };

  const selectStudent = (studentInfo, reset = true) => {
    const { studentId } = studentInfo;
    if (studentInfo.studentId !== 'null' && studentId) {
      AxiosTS.Business('public/studentFace/getFacesByStudentId', {
        studentId: studentInfo.studentId
      }).then(res => {
        setImageList(res.result);
        setStudentInfo(studentInfo);
        setDataUrl(null);
        setSubmiting(false);
        setHasStudent(true);
      });
    }
  };

  const clear = () => {
    setDataUrl(null);
    setImageList([]);
    setStudentInfo({});
    setHasStudent(false);
    setSubmit(false);
    setSubmiting(false);
  };

  const takePhoto = () => {
    if (imageList.length > 1) {
      message.warning('每个学员最多录入2张照片，请先删除一张');
      return;
    }

    try {
      //获得Canvas对象
      let video = document.getElementById('video');
      let canvas = document.getElementById('canvas_up');
      let ctx = canvas.getContext('2d');
      ctx.drawImage(video, 0, 0, 890, 580);
      setTimeout(() => {
        const _dataUrl = canvas.toDataURL('image/jpeg');
        setDataUrl(_dataUrl);
        setSubmit(false);
        const input = document.getElementById('myImg'); //  帧图 img
        const options = new faceapi.TinyFaceDetectorOptions({ inputSize, scoreThreshold }); // 人脸识别参数
        faceapi.detectAllFaces(input, options).then(result => {
          // 人脸识别  使用img
          // console.log(result, 'faceDetectResult')
          if (result.length > 1) {
            message.warning('人脸采集不可以有多人');
            setSubmit(true);
          } else {
            const Blob = convertBase64ToBlob(_dataUrl);
            const resourceName = '人脸考勤'+ studentInfo.studentId+'.jpeg';
            var params = {
              blob:Blob,
              name: resourceName,
              type:'image/jpeg',
              studentId: studentInfo.studentId,
              dataType: 'id',
              bizCode:'UPLOAD_REGISTER_STUDENT_FACE'
            };
            Upload.newUploadBlobToOSS(params).then((res) => {
              setResourceId(res.resourceId);
            });
          }
        });
      }, 200);
    } catch (error) {}
  };

  const handleDeleteImg = info => {
    Modal.confirm({
      title: `确定要删除该照片吗`,
      onCancel() {},
      onOk() {
        AxiosTS.Business('public/studentFace/delete', {
          id: info.id
        }).then(res => {
          selectStudent(studentInfo, false);
          message.success('删除成功');
        });
      }
    });
  };

  // 上传成功回调
  const initStatus = () => {
    setResourceId('');
    selectStudent(studentInfo, false);
  };

  // 删除历史/潜在学员人脸信息
  // 录入新的人脸信息
  const handleHistoryFaceInfo = faceId => {
    AxiosTS.Business('public/studentFace/delete', { id: faceId[0] }).then(res => {
      // 加延时防止 delete 接口返回成功但实际删除操作还没有完成
      setTimeout(() => {
        AxiosTS.Business('public/studentFace/register', {
          instId: window.userAdminInfo.instId,
          studentId: studentInfo.studentId,
          resourceId
        }).then(res => {
          initStatus();
          message.success('上传成功');
        });
      }, 200);
    });
  };

  const uploadImg = () => {
    setSubmit(true);
    setSubmiting(true);
    AxiosTS.Business('public/studentFace/register', {
      instId: window.userAdminInfo.instId,
      resourceId: resourceId,
      studentId: studentInfo.studentId
    })
      .then(res => {
        // 不为空说明有相似的人脸信息
        if (!_.isEmpty(res.result)) {
          const { faceId = [], status = '', studentName = '' } = res.result;
          // 在读学员
          if (status === 'NORMAL') {
            Modal.warning({
              title: '提示',
              okText: '我知道了',
              content: <span>人脸信息已被在读学员【{studentName}】占用，建议检查后，再录入人脸信息</span>,
              icon: <span className='icon iconfont default-confirm-icon'>&#xe6e0;</span>,
              onOk: () => {
                initStatus();
              }
            });
          }
          // 历史/潜在学员
          else if (status === 'POTENTIAL' || status === 'HISTORY') {
            Modal.confirm({
              title: '提示',
              cancelText: '暂不录入',
              content: <span>人脸信息已被历史/潜在学员【{studentName}】占用，确定删除原学员的人脸并录入新学员的人脸吗？</span>,
              icon: <span className='icon iconfont default-confirm-icon'>&#xe6e0;</span>,
              onCancel: () => {
                initStatus();
              },
              onOk: () => {
                handleHistoryFaceInfo(faceId);
              }
            });
          }
          return;
        }

        initStatus();
        message.success('上传成功');
      })
      .catch(() => {
        setSubmiting(false);
        // message.warning('未识别到人脸')
      });
  };

  /**
   * 家长端采集人脸开关的值改变时的函数
   */
  function faceSwitchOnChange(value) {
    if (checked) {
      return Modal.confirm({
        title: '关闭家长端人脸采集入口',
        content: '关闭后，家长端将不展示人脸采集入口',
        onOk() {
          const param = {
            instId: window.currentUserInstInfo.instId,
            configType: 'OPEN_C_FACE',
            configValue: 'false'
          };
          AxiosTS.Business('public/config/modifyCampusConfig', param).then(res => {
            setCheckedValue();
          });
        }
      });
    }
    const param = {
      instId: window.currentUserInstInfo.instId,
      configType: 'OPEN_C_FACE',
      configValue: 'true'
    };
    AxiosTS.Business('public/config/modifyCampusConfig', param).then(res => {
      setCheckedValue();
    });
  }

  /**
   * 生成二维码
   */
  function generateQrcode() {
    const appId = window.currentUserInstInfo.appId || '';
    const instId = window.currentUserInstInfo.instId || '';
    let env = 'dev';
    switch (process.env.DEPLOY_ENV) {
      case 'dev':
      case 'rc':
        env = process.env.DEPLOY_ENV;
        break;
      case 'gray':
      case 'prod':
        env = 'res';
        break;
      default:
        break;
    }
    const link = `https://${env}.xiaomai5.com/h5/${
      process.env.DEPLOY_ENV === 'gray' ? 'gray/' : ''
    }index.html#face/info?appid=${appId}&from=face_qrcode&inst_id=${instId}`;
    const params = {
      bizId: instId,
      instId,
      longUrl: link,
      shareType: 'INST_FACE'
    };
    AxiosTS.postJSON('zeus/public/share/getShareTool', params).then(res => {
      console.log(res,'ressss')
      const {qrCode}=res.result;
      setCollectionImg(qrCode)
    });
  }

 
  //下载小程序二维码
  function downloadIamge () {
    downloadBase64Img(collectionImg,'录入学员人脸信息.png');
  }

  function downloadBase64Img(base64URL,fileName) {  
    // 创建a标签，用于触发下载  
    const a = document.createElement('a');  
    // 将 a 标签的 download 属性设置为要下载的文件名  
    a.download = fileName || 'image';  
    // 创建 Blob 对象，并获取 base64 数据的 MIME 类型  
    const mimeType = base64URL.match(/:(.*?);/)[1];  
    // 将 base64 数据转换为字节数组  
    const byteCharacters = atob(base64URL.split(',')[1]);  
    const byteNumbers = new Array(byteCharacters.length);  
    // 将字节数组填充到 Uint8Array 中  
    for (let i = 0; i < byteCharacters.length; i++) {  
      byteNumbers[i] = byteCharacters.charCodeAt(i);  
    }  
    const byteArray = new Uint8Array(byteNumbers);  
    // 创建 Blob 对象  
    const blob = new Blob([byteArray], {type: mimeType});  
    // 将 Blob 对象的 URL 赋值给 a 标签的 href 属性  
    a.href = URL.createObjectURL(blob);  
    // 将a标签暂时添加到 body 中，触发下载  
    document.body.appendChild(a);  
    a.click();  
    // 下载完成后，将 a 标签从 body 中移除  
    document.body.removeChild(a);  
  } 

  return (
    <div className='page__content'>
      <div className='admin-opration'>
        <div style={{ display: 'flex' }}>
          <span
            style={{ marginRight: 12 }}
            className='opration-btn'
            onClick={() => {
              setQrcodeModalFlag(true);
              generateQrcode();
            }}
          >
            分享采集二维码
          </span>
          <span
            className='opration-btn'
            onClick={() => {
              setParentEntryFlag(true);
              setCheckedValue();
            }}
          >
            设置家长端采集
          </span>
        </div>
        <div className='admin-opration-cozy-tips'>
          <span
            className='icon iconfont'
            style={{
              color: '#FF8534',
              marginRight: 5,
              position: 'relative',
              top: 1
            }}
          >
            &#xe6f0;
          </span>
          温馨提示：人脸采集完成后，请前往【
          <strong>人脸考勤签到</strong>
          】刷脸签到
        </div>
      </div>
      <div style={{ position: 'absolute', left: -10000 }}>
        <img id='testimg' src='./test.jpg' alt='test图片' />
      </div>
      <div className='canvasBox'>
        <img id='myImg' src={dataUrl} alt='myImg' />
        <canvas width='890' height='580' id='canvas_up'></canvas>
      </div>
      <div className='face__main'>
        <div className='faceDetect'>
          <Outline />
          <div className="marquee-wrap">
            <div className="notice-content">我们将收集您的人脸信息，并同步给{window.userAdminInfo.instName}/百度/宇泛用于学员考勤</div>
          </div>
          <div className='faceBox'>
            {!!nodevice && (
              <div className='bag noPadding'>
                <p className='noDevice'>请检测摄像头设备是否正确连接，并允许访问！</p>
              </div>
            )}
            {!nodevice && status === 1 && (
              <div className='bag'>
                <div className='lottie-box'>
                  <img src='https://image.xiaomaiketang.com/xm/MDj8WSW32P.gif' alt='人脸系统打开中的显示图片' />
                  <p className='face__opening'>人脸系统打开中…</p>
                </div>
              </div>
            )}
            {status === 2 && (
              <div className='bag noPadding' style={{ height: '100%' }}>
                <video id='video' muted autoPlay='autoplay' width='100%' height='100%'></video>
              </div>
            )}
          </div>
        </div>
        <div className='rightBox'>
          <p className='select__title' style={{ marginBottom: 8 }}>
            选择学员进行人脸采集
          </p>
          <StudentSearchSelect
            label=''
            placeholder='选择学员进行人脸采集'
            queryAll={true}
            teacherId={null}
            onSelect={selectStudent}
            clear={clear}
            defaultValue={studentInfo.studentName}
            studentName={studentInfo.studentName}
          ></StudentSearchSelect>
          {!!hasStudent && (
            <div className='studentInfoList'>
              <p className='student__basic'>
                {studentInfo.studentName}&nbsp;&nbsp;{studentInfo.phone}
              </p>
              {!!dataUrl && (
                <div className='img'>
                  <Spin indicator={antIcon} spinning={submiting}>
                    <img className='face__img' src={dataUrl} alt='face_img' />
                  </Spin>
                </div>
              )}
              {!dataUrl &&
                (imageList.length ? (
                  imageList.map((item, index) => {
                    return (
                      <div className='' style={{ marginTop: 12 }} key={item.id}>
                        <div className='img'>
                          <img className='face__img' src={item.imageUrl} alt='face_img' />
                          <div
                            onClick={() => {
                              handleDeleteImg(item);
                            }}
                            className='close'
                          >
                            <img src='https://image.xiaomaiketang.com/xm/ZQsZPQNfBG.png' alt='错误图' />
                          </div>
                        </div>
                      </div>
                    );
                  })
                ) : (
                  <div className='noimg'>
                    <img src='https://image.xiaomaiketang.com/xm/ebRy7P8y5k.png' alt='未采集人脸图' />
                    <p>未采集人脸</p>
                  </div>
                ))}
            </div>
          )}

          {!!hasStudent && (
            <div className='buttonList'>
              {status === 2 && !dataUrl && (
                <div className='take__photo' onClick={takePhoto}>
                  拍摄
                </div>
              )}
              {!!dataUrl &&
                !submiting && [
                  <div className='re__take' style={{ marginRight: 12 }} onClick={takePhoto}>
                    重新拍摄
                  </div>
                ]}
              {!!dataUrl &&
                !submit &&
                resourceId && [
                  <div className='confirm' onClick={uploadImg}>
                    确认提交
                  </div>
                ]}
            </div>
          )}
        </div>
      </div>
      {qrcodeModalFlag && (
        <Modal
          visible={qrcodeModalFlag}
          title='分享人脸采集二维码'
          width={448}
          footer={null}
          onCancel={() => {
            setQrcodeModalFlag(false);
          }}
        >
          <div className='qicode-modal'>
            <div className='qicode-modal-content'>
              <img src='https://image.xiaomaiketang.com/xm/MyDbEnZJBy.png' className='left-top-corner' alt='左上角' />
              <img src='https://image.xiaomaiketang.com/xm/HTFTQzP2XA.png' className='right-bottom-corner' alt='右下角' />
              <div className='qicode-modal-title'>
                <img src='https://image.xiaomaiketang.com/xm/Rtc8YmzjDC.png' className='title-icon' alt='标题icon图' />
                <h3>{window.currentUserInstInfo.name}</h3>
              </div>
              <p>长按或扫码识别二维码，录入学员人脸信息</p>
              {collectionImg&&<img className='collection_img' src={collectionImg} alt="" />}
            </div>
            <div className='down-img' onClick={downloadIamge}>
              下载图片
            </div>
          </div>
        </Modal>
      )}
      <Modal
        visible={parentEntryFlag}
        title='设置家长端采集入口'
        width={'100rem'}
        footer={null}
        onCancel={() => {
          setParentEntryFlag(false);
        }}
      >
        <div className='parent-entry-modal'>
          <div className='face-acquisition-switch'>
            <span className='face-acquisition-switch-title'>家长端采集人脸</span>
            <Switch
              checked={checked}
              onChange={faceSwitchOnChange}
              style={{
                position: 'relative',
                top: -1
              }}
            />
            <span className='face-acquisition-switch-tips'>
              <span className='icon iconfont' style={{ color: '#BFBFBF', marginRight: 5 }}>
                &#xe6f0;
              </span>
              开启后，家长端将展示人脸采集入口，家长可自行上传学员的人脸信息
            </span>
          </div>
          <div className='face-location-description'>
            <h3>家长端人脸采集位置说明</h3>
            <ul>
              <li>
                <span>位置 ①</span>
                <img src='https://image.xiaomaiketang.com/xm/sm2QP3bY7c.png' alt='预览图片1' width={284} height={459} />
              </li>
              <li>
                <span>位置 ②</span>
                <img src='https://image.xiaomaiketang.com/xm/ebnHWkHQrK.png' alt='预览图片2' width={284} height={459} />
              </li>
              <li>
                <span>位置 ③</span>
                <img src='https://image.xiaomaiketang.com/xm/FcDYeRAAW2.png' alt='预览图片3' width={284} height={459} />
              </li>
            </ul>
          </div>
        </div>
      </Modal>
    </div>
  );
};

export default AttendPage;
